<template>
  <div class="dashboard-contenedor">
    <SlideBar @cambiar-estado="actualizarSidebar" />

    <div class="contenido" :class="{ 'contenido-expandido': sidebarCerrado }">
      <div class="encabezado">
        <div>
          <p class="eyebrow">Administración</p>
          <h2>Usuarios y doctores</h2>
        </div>
        <div class="header-acciones">
          <label class="toggle-eliminados">
            <input type="checkbox" v-model="mostrarEliminados">
            Mostrar eliminados
          </label>
          <button class="btn-primary" @click="abrirModalRegistro">Registrar doctor</button>
        </div>
      </div>

      <p v-if="cargando" class="mensaje-cargando">Cargando usuarios…</p>
      <p v-else-if="!doctoresVisibles.length" class="mensaje-vacio">
        {{ mostrarEliminados ? 'No hay usuarios eliminados.' : 'No hay usuarios registrados.' }}
      </p>

      <!-- MASTER: Tabla -->
      <div v-else class="master-contenedor">
        <div class="tabla-wrapper">
          <table class="tabla-master">
            <thead>
              <tr>
                <th>Nombre completo</th>
                <th>Usuario</th>
                <th>Teléfono</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(doctor, index) in doctoresVisibles"
                :key="index"
                :class="{ 'fila-activa': doctorSeleccionado === doctor, 'fila-eliminada': !esActivo(doctor.activo) }"
                @click="seleccionar(doctor)"
              >
                <td>{{ doctor.nombre_completo || '-' }}</td>
                <td>{{ doctor.usuario || '-' }}</td>
                <td>{{ doctor.telefono || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- DETAIL: Panel inferior -->
        <transition name="detalle-fade">
          <div v-if="doctorSeleccionado" class="detalle-panel">
            <div class="detalle-encabezado">
              <h4>
                {{ doctorSeleccionado.nombre_completo || '-' }}
                <span class="detalle-folio">Usuario: {{ doctorSeleccionado.usuario || '-' }}</span>
              </h4>
              <button class="btn-cerrar-detalle" @click="doctorSeleccionado = null">
                <span class="material-icons">close</span>
              </button>
            </div>

            <div class="detalle-cuerpo">
              <div class="detalle-seccion">
                <h5>Datos de contacto</h5>
                <div class="detalle-grid">
                  <div><strong>Cédula</strong><span>{{ doctorSeleccionado.cedula || '-' }}</span></div>
                  <div><strong>Teléfono</strong><span>{{ doctorSeleccionado.telefono || '-' }}</span></div>
                  <div><strong>Correo</strong><span>{{ doctorSeleccionado.correo || '-' }}</span></div>
                </div>
              </div>
              <div class="detalle-seccion">
                <button v-if="esActivo(doctorSeleccionado.activo)" class="btn-eliminar-doctor" @click="eliminarDoctor(doctorSeleccionado)">
                  <span class="material-icons">delete</span> Eliminar
                </button>
                <button v-else class="btn-restaurar-doctor" @click="restaurarDoctor(doctorSeleccionado)">
                  <span class="material-icons">restore_from_trash</span> Restaurar
                </button>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <transition name="modal">
      <div v-if="mostrarModal" class="modal-backdrop" @click.self="cerrarModalRegistro">
        <div class="modal-registro">
          <div class="modal-header">
            <h3>Registrar doctor</h3>
            <button class="btn-cerrar" @click="cerrarModalRegistro"><span class="material-icons">close</span></button>
          </div>

        <form @submit.prevent="registrarDoctor" class="form-registro">
          <div class="modal-body-scroll">
            <div class="campo-grid">
              <div class="campo">
                <label>Nombre</label>
                <input v-model="doctorForm.nombre" class="form-control" required />
              </div>
              <div class="campo">
                <label>Apellido paterno</label>
                <input v-model="doctorForm.apellido_paterno" class="form-control" required />
              </div>
            </div>

            <div class="campo-grid">
              <div class="campo">
                <label>Apellido materno</label>
                <input v-model="doctorForm.apellido_materno" class="form-control" />
              </div>
              <div class="campo">
                <label>Cédula</label>
                <input v-model="doctorForm.cedula" class="form-control" />
              </div>
            </div>

            <div class="campo-grid">
              <div class="campo">
                <label>Contraseña</label>
                <input v-model="doctorForm.contraseña" type="password" class="form-control" required />
              </div>
              <div class="campo">
                <label>Teléfono</label>
                <input v-model="doctorForm.telefono" class="form-control" required />
              </div>
            </div>

            <div class="campo-grid">
              <div class="campo">
                <label>Correo</label>
                <input v-model="doctorForm.correo" type="email" class="form-control" required />
              </div>
              <div class="campo">
                <label>Rango</label>
                <select v-model="doctorForm.rango" class="form-select" required>
                  <option value="doctor">Doctor</option>
                  <option value="nutriologo">Nutriólogo</option>
                  <option value="psicologo">Psicólogo</option>
                  <option value="jefe">Jefe</option>
                  <option value="administrador">Administrador</option>
                </select>
              </div>
            </div>
          </div>

          <div class="modal-footer-sticky">
            <button type="submit" class="btn-primary btn-submit" :disabled="cargandoRegistro">
              {{ cargandoRegistro ? 'Registrando...' : 'Registrar doctor' }}
            </button>
          </div>
        </form>
      </div>
    </div>
    </transition>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import SlideBar from './SlideBar.vue';
import { getUsuarios, addUsuario, setUsuarioActivo } from '@/utils/api';

export default {
  name: 'AdministradorUsuarios',
  components: {
    SlideBar,
  },
  data() {
    return {
      sidebarCerrado: false,
      doctores: [],
      doctorSeleccionado: null,
      cargando: false,
      cargandoRegistro: false,
      mostrarModal: false,
      mostrarEliminados: false,
      doctorForm: {
        nombre: '',
        apellido_paterno: '',
        apellido_materno: '',
        cedula: '',
        contraseña: '',
        telefono: '',
        correo: '',
        rango: 'doctor',
      },
    };
  },
  computed: {
    doctoresVisibles() {
      return this.doctores.filter(d => {
        const activo = this.esActivo(d.activo);
        return this.mostrarEliminados ? !activo : activo;
      });
    },
  },
  mounted() {
    this.cargarDoctores();
  },
  methods: {
    esActivo(val) {
      return val === true || val === 1 || val === '1';
    },
    async eliminarDoctor(doctor) {
      await setUsuarioActivo(doctor.id, false);
      this.doctorSeleccionado = null;
      this.cargarDoctores();
    },

    async restaurarDoctor(doctor) {
      await setUsuarioActivo(doctor.id, true);
      this.cargarDoctores();
    },
    actualizarSidebar(estado) {
      this.sidebarCerrado = estado;
    },

    seleccionar(doctor) {
      this.doctorSeleccionado = this.doctorSeleccionado === doctor ? null : doctor;
    },

    async cargarDoctores() {
      this.cargando = true;
      this.doctores = await getUsuarios();
      this.cargando = false;
    },

    abrirModalRegistro() {
      this.mostrarModal = true;
    },

    cerrarModalRegistro() {
      this.mostrarModal = false;
    },

    async registrarDoctor() {
      const camposObligatorios = ['nombre', 'apellido_paterno', 'contraseña', 'telefono', 'correo', 'rango'];
      const hayCamposVacios = camposObligatorios.some((campo) => !String(this.doctorForm[campo]).trim());

      if (hayCamposVacios) {
        Swal.fire({
          icon: 'warning',
          title: 'Completa el formulario',
          text: 'Faltan datos obligatorios para registrar el doctor.',
          confirmButtonColor: '#133e68',
        });
        return;
      }

      this.cargandoRegistro = true;
      try {
        await addUsuario({ ...this.doctorForm });

        this.cerrarModalRegistro();
        this.cargarDoctores();

        Swal.fire({
          icon: 'success',
          title: 'Doctor registrado',
          text: 'El usuario se registró correctamente.',
          confirmButtonColor: '#133e68',
        });

        this.doctorForm = {
          nombre: '',
          apellido_paterno: '',
          apellido_materno: '',
          cedula: '',
          contraseña: '',
          telefono: '',
          correo: '',
          rango: 'doctor',
        };
        this.cerrarModalRegistro();
        this.cargarDoctores();
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error al registrar',
          text: error.message || 'Ocurrió un problema al enviar el formulario.',
          confirmButtonColor: '#d33',
        });
      } finally {
        this.cargandoRegistro = false;
      }
    },
  },
};
</script>

<style scoped>
/* ---------- LAYOUT ---------- */
.dashboard-contenedor {
  display: flex;
  min-height: 100vh;
  background-color: var(--brand-beige);
}

.contenido {
  flex-grow: 1;
  padding: 24px;
  margin-left: 250px;
  transition: margin-left 0.3s ease;
}

.contenido-expandido {
  margin-left: 80px;
}

/* ---------- ENCABEZADO ---------- */
.encabezado {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.eyebrow {
  color: var(--brand-accent-sage);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin: 0 0 4px;
}

.encabezado h2 {
  margin: 0;
  color: var(--brand-primary);
}

.btn-primary {
  background: var(--brand-primary);
  color: #ffffff;
  border: none;
  border-radius: 10px;
  padding: 10px 16px;
  font-weight: 700;
  cursor: pointer;
}

.btn-primary:hover {
  background: var(--brand-accent-navy);
}

.header-acciones {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.toggle-eliminados {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--brand-secondary);
  cursor: pointer;
  white-space: nowrap;
}

.fila-eliminada { opacity: 0.55; }

.btn-eliminar-doctor,
.btn-restaurar-doctor {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-eliminar-doctor {
  background: rgba(211, 51, 51, 0.1);
  color: #d33;
}

.btn-eliminar-doctor:hover { background: rgba(211, 51, 51, 0.2); }

.btn-restaurar-doctor {
  background: rgba(96, 127, 112, 0.12);
  color: var(--brand-accent-sage);
}

.btn-restaurar-doctor:hover { background: rgba(96, 127, 112, 0.22); }

.btn-eliminar-doctor .material-icons,
.btn-restaurar-doctor .material-icons { font-size: 16px; }

.btn-submit {
  width: 100%;
  margin-top: 6px;
  transition: background 0.2s, transform 0.15s;
}

.btn-submit:hover {
  transform: translateY(-1px);
}

/* ---------- MASTER: TABLA ---------- */
.master-contenedor {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.tabla-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  background: var(--white);
  border-radius: 12px 12px 0 0;
  box-shadow: 0 4px 16px rgba(19, 62, 104, 0.10);
}

.tabla-master {
  width: 100%;
  min-width: 480px;
  border-collapse: collapse;
  background: var(--white);
}

.tabla-master thead {
  background: var(--brand-primary);
  color: var(--white);
}

.tabla-master th {
  padding: 14px 16px;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  letter-spacing: 0.4px;
}

.tabla-master tbody tr {
  border-bottom: 1px solid rgba(19, 62, 104, 0.08);
  cursor: pointer;
  transition: background 0.15s ease;
}

.tabla-master tbody tr:last-child {
  border-bottom: none;
}

.tabla-master tbody tr:hover {
  background: rgba(96, 127, 112, 0.08);
}

.tabla-master tbody tr.fila-activa {
  background: rgba(96, 127, 112, 0.18);
}

.tabla-master td {
  padding: 13px 16px;
  font-size: 14px;
  color: var(--brand-secondary);
}

/* ---------- DETAIL: PANEL ---------- */
.detalle-panel {
  background: var(--white);
  border-top: 3px solid var(--brand-accent-sage);
  border-radius: 0 0 12px 12px;
  box-shadow: 0 8px 24px rgba(19, 62, 104, 0.12);
  overflow: hidden;
}

.detalle-encabezado {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: var(--brand-primary);
  color: var(--white);
}

.detalle-encabezado h4 {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  color: var(--white);
  display: flex;
  align-items: center;
  gap: 12px;
}

.detalle-folio {
  font-size: 13px;
  font-weight: 400;
  opacity: 0.75;
}

.btn-cerrar-detalle {
  background: none;
  border: none;
  color: var(--white);
  cursor: pointer;
  display: flex;
  align-items: center;
  opacity: 0.8;
  transition: opacity 0.2s;
}

.btn-cerrar-detalle:hover {
  opacity: 1;
}

.detalle-cuerpo {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.detalle-seccion h5 {
  font-size: 14px;
  font-weight: 700;
  color: var(--brand-accent-sage);
  text-transform: uppercase;
  letter-spacing: 0.6px;
  margin: 0 0 12px;
  padding-bottom: 6px;
  border-bottom: 1px solid rgba(96, 127, 112, 0.2);
}

.detalle-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 12px 24px;
}

.detalle-grid > div {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.detalle-grid strong {
  font-size: 12px;
  color: var(--brand-secondary-light);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.detalle-grid span {
  font-size: 14px;
  color: var(--brand-secondary);
}

/* ---------- TRANSICIÓN ---------- */
.detalle-fade-enter-active,
.detalle-fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.detalle-fade-enter-from,
.detalle-fade-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

/* ---------- MENSAJES ---------- */
.mensaje-cargando,
.mensaje-vacio {
  color: var(--brand-primary);
  font-weight: 600;
  text-align: center;
  padding: 40px;
  font-size: 16px;
}

/* ---------- MODAL ---------- */
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1400;
  padding: 16px;
}

.modal-registro {
  width: min(600px, 95vw);
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  max-height: 86vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0;
}

.modal-header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #e8edf2;
  margin-bottom: 0;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  color: var(--brand-primary);
}

.btn-cerrar {
  border: none;
  background: transparent;
  cursor: pointer;
  color: #666;
  display: flex;
  align-items: center;
  padding: 4px;
  border-radius: 4px;
  transition: background 0.2s;
}

.btn-cerrar:hover {
  background: #f0f4f8;
}

.btn-cerrar .material-icons {
  font-size: 22px;
}

.form-registro {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  gap: 0;
}

.modal-body-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  overscroll-behavior: contain;
}

.modal-body-scroll::-webkit-scrollbar {
  width: 7px;
}

.modal-body-scroll::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}

.modal-body-scroll::-webkit-scrollbar-thumb {
  background: #9ab4a7;
  border-radius: 4px;
}

.modal-body-scroll::-webkit-scrollbar-thumb:hover {
  background: var(--brand-primary, #133e68);
}

.modal-footer-sticky {
  flex-shrink: 0;
  padding: 14px 20px;
  background: #ffffff;
  border-top: 1px solid #e8edf2;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.04);
}

.campo-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.campo {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.campo label {
  font-size: 12px;
  font-weight: 600;
  color: var(--brand-secondary);
}

.form-control,
.form-select {
  width: 100%;
  border-radius: 8px;
  border: 1px solid #d6e0eb;
  padding: 8px 10px;
  font-size: 13px;
  background: #ffffff;
  color: var(--brand-primary);
  box-sizing: border-box;
}

/* ---------- RESPONSIVE ---------- */
@media (max-width: 1024px) {
  .contenido { margin-left: 80px; }
}

@media (max-width: 768px) {
  .dashboard-contenedor { flex-direction: column; }

  .contenido {
    margin-left: 0 !important;
    padding: 12px;
    padding-top: 70px;
  }

  .encabezado {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .tabla-master th,
  .tabla-master td { padding: 10px 8px; font-size: 13px; }

  .detalle-encabezado h4 { font-size: 14px; }
  .detalle-cuerpo { padding: 14px; gap: 14px; }

  .campo-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .contenido { padding: 8px; padding-top: 70px; }
  .detalle-grid { grid-template-columns: 1fr; }
}
</style>
